export function showTab(tabFamily, tabName) {
  const slide = Reveal.getCurrentSlide();

  const tabContents: NodeListOf<HTMLDivElement> = slide.querySelectorAll(
    `.${tabFamily}`
  );
  for (const tabContent of tabContents) {
    tabContent.style.display = tabContent.id === tabName ? "block" : "none";
  }
}

window.showTab = showTab;
